module.exports = __webpack_public_path__ + "img/banner_pt.09d91f8d.jpg";